import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import BackToButton from "../../../../../shared/backToButton/BackToButton";
import SubNav from "../../../../../shared/subnav/SubNav";
import { ValidatorForm } from "react-material-ui-form-validator";
import Grid from "@material-ui/core/Grid";
import CheckBox from "../../../../../shared/checkBox/CheckBox";
import styles from "./ModifyReservationPrice.module.scss";
import { InfoIconWithMessage } from "../../../../../shared/infoIcon/InfoIcon";
import { PricesApplied } from "../../../../../shared/feedback/PricesApplied";
import commonStyles from "../../../../../styles/common/CommonStyles.module.scss";
import ValidationRules from "../../../../../common/ValidationRules";
import ReservationPriceClient from "../../../../../shared/clients/ReservationPriceClient";
import {
  displayError,
  ERROR_PROCESSING,
  isProcessingError,
} from "../../../../../errors/ErrorConstants";
import PendingActionClient from "../../../../../shared/clients/PendingActionClient";
import { RESERVATION_DEPOSIT } from "../../../../../common/Constants";
import ReservationList from "./ReservationList";
import TypeOfVehicleDropdown from "./TypeOfVehicleDropdown";
import { MarketGroups } from "../../../../../shared/marketGroups/MarketGroups";

class ModifyReservationPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reservations: [],
      deletedFields: [],
      editMode: false,
      pricesApplied: false,
      isDataLoaded: false,
      checkedCount: 0,
      checkAll: false,
      validForm: true,
      buttonDisabled: true,
      hasError: false,
      savedCount: 0,
      vehicleType: this.props.t("ModifyReservationPrice.passengerVehicles"),
      currencySymbol:
        this.props.localizedInfo && this.props.localizedInfo.defaultCurrency
          ? this.props.localizedInfo.defaultCurrency.symbol
          : this.props.t("CurrentPricing.na"),
      vehicleLineMap: {},
    };

    this.userCanEdit =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "depositPrice:write"
      ) &&
      this.userHasNoDealerRestrictions() &&
      !this.props.fromNscDealerSearch;
    this.userCanViewDropdown =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "resPriceDropdown:view"
      );
    this.subheader = this.props.isNsc
      ? this.props.t("ModifyReservationPrice.subheaderNsc")
      : this.props.t("ModifyReservationPrice.subheaderPricing");
    this.formRef = React.createRef();
    this.listOfVehicleTypes = [
      this.props.t("ModifyReservationPrice.passengerVehicles"),
      this.props.t("ModifyReservationPrice.commercialVehicles"),
    ];
    this.showNscDropdown =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "orderSearchMarketDropDown:view"
      );
  }

  componentDidMount() {
    ValidationRules();
    this.retrieveReservations();
  }

  onTypeOfVehicleChange = (e) => {
    const value = e.target.value;
    const filterType =
      value === this.props.t("ModifyReservationPrice.passengerVehicles")
        ? "PV"
        : "CV";
    this.setState((prevState) => ({
      vehicleType: value,
      reservations: prevState.allResults[filterType],
    }));
  };

  onClickEdit = () => {
    this.setState((prevState) => ({
      editMode: !prevState.editMode,
    }));
  };
  onMarketChange = (event) => {
    event.preventDefault();
    const market = event.target.value;

    this.props.updateCurrentMarket(market);
    this.retrieveReservations();
    this.setState({ currencySymbol: this.getCurrencySymbol() });
  };

  getCurrencySymbol() {
    if (this.props.localizedInfo && this.props.localizedInfo.defaultCurrency) {
      return this.props.localizedInfo.defaultCurrency.symbol;
    }
    return "";
  }

  checkAll = (e) => {
    const checked = e.target.checked;
    const reservationsCopy = JSON.parse(
      JSON.stringify(this.state.reservations)
    );

    reservationsCopy.forEach((res) => {
      res.checked = checked;
    });

    this.setState(
      {
        pricesApplied: false,
        reservations: reservationsCopy,
        checkedCount: checked ? reservationsCopy.length : 0,
        checkAll: checked,
      },
      () => this.checkButtonDisabled()
    );
  };

  checkItem = (e) => {
    const index = e.target.value;
    const checked = e.target.checked;
    const reservationsCopy = JSON.parse(
      JSON.stringify(this.state.reservations)
    );
    let currentCount = this.state.checkedCount;

    reservationsCopy[index].checked = checked;
    currentCount = checked ? currentCount + 1 : currentCount - 1;

    this.setState(
      {
        pricesApplied: false,
        reservations: reservationsCopy,
        checkedCount: currentCount,
        checkAll: currentCount === reservationsCopy.length,
      },
      () => this.checkButtonDisabled()
    );
  };

  retrieveReservations() {
    this.props.hideOrShow(true);
    ReservationPriceClient.retrieveReservationPrices(
      this.props.user,
      this.props.selectedMarket
    )
      .then((result) => {
        this.getVehicleLineMap(result);
        result = this.formatResponse(result);

        if (this.userCanViewDropdown) {
          const filterKey =
            this.state.vehicleType ===
            this.props.t("ModifyReservationPrice.passengerVehicles")
              ? "PV"
              : "CV";
          this.setState({
            reservations: result.filter(
              (item) => item.vehicleType === filterKey
            ),
            allResults: {
              PV: result.filter((item) => item.vehicleType === "PV"),
              CV: result.filter((item) => item.vehicleType === "CV"),
            },
          });
        } else {
          this.setState({
            reservations: result,
          });
        }
      })
      .catch(() => {})
      .finally(() => {
        this.props.hideOrShow(false);
        this.setState({ isDataLoaded: true });
      });
  }

  getVehicleLineMap = (reservations) => {
    const vehicleLineMap = {};
    reservations.forEach((reservation) => {
      vehicleLineMap[reservation.vehicleLine] = reservation.catalogId;
    });
    this.setState({ vehicleLineMap });
  };

  formatResponse(result) {
    result.forEach((item) => {
      if (!isNaN(item.amount) && this.hasAmount(item.amount)) {
        item.amount = parseFloat(item.amount).toFixed(2);
        item.checked = false;
      }
    });
    return this.removeDuplicates(result);
  }

  removeDuplicates = (reservations) => {
    const seenModels = new Map();
    const filteredReservations = [];
    reservations.forEach((reservation) => {
      if (seenModels.has(reservation.model)) {
        const functionToFindModel = (element) =>
          element.model === reservation.model;
        const indexOfReservation =
          filteredReservations.findIndex(functionToFindModel);

        filteredReservations[indexOfReservation].newVehicleLine =
          reservation.newVehicleLine && reservation.newVehicleLine;

        if (!this.props.isNsc) {
          filteredReservations[indexOfReservation].amount = reservation.amount;
        } else {
          filteredReservations[indexOfReservation].amount =
            !reservation.newVehicleLine ? reservation.amount : null;
        }
        if (
          Array.isArray(filteredReservations[indexOfReservation].vehicleLine)
        ) {
          filteredReservations[indexOfReservation].vehicleLine.push(
            reservation.vehicleLine
          );
        } else {
          filteredReservations[indexOfReservation].vehicleLine = [
            filteredReservations[indexOfReservation].vehicleLine,
            reservation.vehicleLine,
          ];
        }
      } else {
        seenModels.set(reservation.model, 0);
        filteredReservations.push(reservation);
      }
    });

    return filteredReservations;
  };

  convertReservations = (reservations) => {
    const newReservations = [];

    for (const i in reservations) {
      const reservation = reservations[i];

      if (Array.isArray(reservation.vehicleLine)) {
        reservation.vehicleLine.forEach((vehicleLine) => {
          const newReservation = { ...reservation };
          newReservation.vehicleLine = vehicleLine;
          newReservation.catalogId = this.state.vehicleLineMap[vehicleLine];
          newReservations.push(newReservation);
        });
      } else {
        newReservations.push(reservation);
      }
    }

    return newReservations;
  };

  saveNscPrices(reservations, vehicleLines) {
    this.props.hideOrShow(true);
    ReservationPriceClient.updateNscReservationPrice(
      this.props.user,
      reservations,
      this.props.selectedMarket
    )
      .then(() => {
        this.updateNscPendingActions(vehicleLines);
        this.retrieveReservations();
        this.resetState();
      })
      .catch((e) => {
        if (isProcessingError(e)) {
          this.setState({ hasError: [ERROR_PROCESSING] });
        }
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  }

  hasAmount = (amount) => {
    return amount !== "" && amount !== null && amount !== false;
  };

  updateNscPendingActions(vehicleLines) {
    this.props.hideOrShow(true);
    PendingActionClient.removeNscPendingAction(
      this.props.user,
      RESERVATION_DEPOSIT,
      vehicleLines,
      this.props.selectedMarket
    )
      .then(() => this.props.getPendingActions())
      .catch((e) => {
        if (isProcessingError(e)) {
          this.setState({ hasError: [ERROR_PROCESSING] });
        }
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  }

  saveDealerPrices(reservations, vehicleLines) {
    this.props.hideOrShow(true);
    ReservationPriceClient.updateDealerReservationPrice(
      this.props.user,
      reservations,
      this.props.user.getDealerList()
    )
      .then(() => {
        this.updateDealerPendingActions(vehicleLines);
        this.retrieveReservations();
        this.resetState();
      })
      .catch((e) => {
        if (isProcessingError(e)) {
          this.setState({ hasError: [ERROR_PROCESSING] });
        }
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  }

  updateDealerPendingActions(vehicleLines) {
    PendingActionClient.removeDealerPendingAction(
      this.props.user,
      this.props.user.getDealerList(),
      RESERVATION_DEPOSIT,
      vehicleLines
    )
      .then(() => this.props.getPendingActions())
      .catch((e) => {
        if (isProcessingError(e)) {
          this.setState({ hasError: [ERROR_PROCESSING] });
        }
      })
      .finally(() => {
        this.props.hideOrShow(false);
        this.props.user.dealerGroupingsMap &&
          this.props.user.updateUnOnboardedDealers(
            this.props.user.getDealerList(),
            RESERVATION_DEPOSIT
          );
        this.props.user.updateToggleDisabled(
          this.props.user.getDealerList(),
          RESERVATION_DEPOSIT
        );
      });
  }

  resetState() {
    this.setState((prevState) => ({
      deletedFields: [],
      editMode: false,
      savedCount: prevState.checkedCount,
      pricesApplied: true,
      checkedCount: 0,
      checkAll: false,
      validForm: true,
      buttonDisabled: false,
    }));
  }

  userHasNoDealerRestrictions = () => {
    if (this.props.isNsc) {
      return true;
    }
    const currentDealer = this.props.user.dealerGroup.filter(
      (dealer) => dealer.commonId === this.props.user.commonId
    )[0];
    const isMainViewingSDLR = this.props.isMainViewingSDLR(currentDealer);
    return !isMainViewingSDLR;
  };

  uploadPrice = () => {
    const reservationsCopy = JSON.parse(
      JSON.stringify(this.state.reservations)
    );
    const filtered = reservationsCopy.filter(
      (res) => res.checked && this.hasAmount(res.amount)
    );
    filtered.forEach((res) => (res.amount = parseFloat(res.amount).toFixed(2)));
    const convertedRes = this.convertReservations(filtered);
    const vehicleLines =
      convertedRes &&
      convertedRes.map((reservation) => reservation.vehicleLine).flat();
    this.props.isNsc
      ? this.saveNscPrices(convertedRes, vehicleLines)
      : this.saveDealerPrices(convertedRes, vehicleLines);
  };

  updateReservation = (e, idx) => {
    const input = e.target.value;
    const reservationsCopy = JSON.parse(
      JSON.stringify(this.state.reservations)
    );
    const deletedCopy = [...this.state.deletedFields];

    // Tracking fields that have been deleted for form validation
    // Form validator cannot enforce "required" as some fields will come in blank
    if (input === "") {
      if (!deletedCopy.includes(idx)) {
        deletedCopy.push(idx);
      }
    } else {
      if (deletedCopy.includes(idx)) {
        deletedCopy.splice(deletedCopy.indexOf(idx), 1);
      }
    }

    reservationsCopy[idx].amount = input;
    this.setState(
      { reservations: reservationsCopy, deletedFields: deletedCopy },
      () => {
        this.formRef.current.isFormValid().then((valid) => {
          this.setState(
            {
              validForm: valid && this.state.deletedFields.length === 0,
            },
            () => this.checkButtonDisabled()
          );
        });
      }
    );
  };

  checkButtonDisabled() {
    // Check if at least one fields has been checked and is not empty
    const updatedPrices = this.hasChangedReservationPrices();
    // check if from dealersearch
    const fromDealerSearch =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "depositPriceSubmit"
      ) && this.props.fromNscDealerSearch;
    const disabled =
      !this.state.validForm || !updatedPrices || fromDealerSearch;
    this.setState({ buttonDisabled: disabled });
  }

  hasChangedReservationPrices() {
    // User must check at least one, must not check any without a value
    let countChanged = 0;
    let submittingBlank = false;
    this.state.reservations.forEach((res) => {
      if (res.checked) {
        if (this.hasAmount(res.amount)) {
          countChanged += 1;
        } else {
          submittingBlank = true;
        }
      }
    });
    return countChanged > 0 && !submittingBlank;
  }

  getSubNav = () => {
    return (
      <>
        <BackToButton
          backToUrl="/pricing"
          display={this.props.t("PricingWrapper.backToPricing")}
        />
        <SubNav
          {...this.props}
          title={this.props.t("ModifyReservationPrice.header")}
          renderSubHeader={false}
          subHeader={null}
        />
      </>
    );
  };
  getNscSubNav = () => {
    return (
      <>
        <BackToButton
          backToUrl="/pricing"
          display={this.props.t("PricingWrapper.backToPricing")}
        />
        <SubNav
          dashboard={false}
          showCustomDropdown={false}
          showCustomMarketDropdown={true}
          listOfMarkets={MarketGroups(this.props.user.market)}
          updateMarket={this.onMarketChange}
          title={this.props.t("ModifyReservationPrice.header")}
          {...this.props}
        />
      </>
    );
  };

  getDropdown = () => {
    return (
      <Grid item md={3} xs={4} className={styles.tovDropdown}>
        <p>{this.props.t("ModifyReservationPrice.typeOfVehicle")}</p>
        <TypeOfVehicleDropdown
          selectedVehicleType={this.state.vehicleType}
          listOfVehicleTypes={this.listOfVehicleTypes}
          updateVehicleType={this.onTypeOfVehicleChange}
        />
      </Grid>
    );
  };

  render() {
    if (displayError(this.state.hasError))
      throw new Error(this.state.hasError[0]);
    return (
      this.state.isDataLoaded && (
        <div className="pageWrapper" id="reservationPrices">
          {this.showNscDropdown ? this.getNscSubNav() : this.getSubNav()}
          <div className="pagePaddingLeft pagePaddingTop pagePaddingRight">
            <InfoIconWithMessage message={this.subheader} />
            {this.userCanViewDropdown && this.getDropdown()}
          </div>
          <ValidatorForm
            id="modifyReservationForm"
            onSubmit={this.uploadPrice}
            ref={this.formRef}
          >
            <Grid container className={styles.grid}>
              <Grid item md={8} className={styles.gridHeader}>
                <CheckBox
                  id="checkAll"
                  isDisabled={!this.userCanEdit}
                  checked={this.state.checkAll}
                  onChange={this.checkAll}
                />
                {this.props.t("ModifyReservationPrice.model")}
              </Grid>
              <Grid item md={4} className={styles.gridHeaderRight}>
                {this.props.t("ModifyReservationPrice.deposit")}
                {this.userCanEdit ? (
                  <div
                    id="editReservations"
                    className={`${styles.editPencil} ${
                      !this.state.validForm && styles.editPencilDisabled
                    }`}
                    onClick={this.onClickEdit}
                  >
                    <div className={styles.rectangleStart}>&nbsp;</div>
                    <div className={styles.rectangleEnd}>&nbsp;</div>
                  </div>
                ) : (
                  <div>&nbsp;{this.state.currencySymbol}</div>
                )}
              </Grid>
            </Grid>
            <ReservationList
              reservations={this.state.reservations}
              editMode={this.state.editMode}
              defaultCurrencySymbol={this.state.currencySymbol}
              hasAmount={this.hasAmount}
              updateReservation={this.updateReservation}
              checkItem={this.checkItem}
              userCanEdit={this.userCanEdit}
            />

            {this.userCanEdit ? (
              !this.state.pricesApplied ? (
                <div className={styles.actionContainer}>
                  <button
                    type="submit"
                    id="saveBtn"
                    className={commonStyles.greenBtn}
                    disabled={this.state.buttonDisabled}
                  >
                    {this.props.t("ActionFooter.apply")}{" "}
                    {this.state.checkedCount > 0 ? this.state.checkedCount : ""}{" "}
                    {this.state.checkedCount === 1
                      ? this.props.t("ActionFooter.orderDeposit")
                      : this.props.t("ActionFooter.orderDeposits")}
                  </button>
                </div>
              ) : (
                <PricesApplied
                  success={true}
                  text={`${this.state.savedCount} ${
                    this.state.savedCount === 1
                      ? this.props.t("ActionFooter.orderDeposit")
                      : this.props.t("ActionFooter.orderDeposits")
                  } ${this.props.t("ModifyReservationPrice.published")}`}
                />
              )
            ) : null}
          </ValidatorForm>
        </div>
      )
    );
  }
}

export default withTranslation("emp")(ModifyReservationPrice);
